(function(window) {
  const testId = 'AB-02';
  const variantId = 'variant-1';

  waitFor(pageReady)
    .then(runVariant)
    .catch((err) => console.error(testId, err));

  function runVariant(atcBtn) {
    addNewSection(atcBtn);
    document.body.classList.add(testId);
    console.log(`${testId}: ${variantId}`);
  }

  function addNewSection(atcBtn) {
    const atcWrapper = atcBtn.closest('.module-wrap');
    const points = ['Adaptable barrel sizes', 'No Ammo required', 'Sight safe anywhere'];
    const icon = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.00488C8.39303 2.00488 6.82214 2.48141 5.486 3.37419C4.14985 4.26698 3.10844 5.53593 2.49348 7.02058C1.87852 8.50523 1.71762 10.1389 2.03112 11.715C2.34463 13.2911 3.11846 14.7388 4.25476 15.8751C5.39106 17.0114 6.8388 17.7853 8.4149 18.0988C9.99099 18.4123 11.6247 18.2514 13.1093 17.6364C14.594 17.0214 15.8629 15.98 16.7557 14.6439C17.6485 13.3077 18.125 11.7369 18.125 10.1299C18.1227 7.9757 17.266 5.91039 15.7427 4.38715C14.2195 2.86391 12.1542 2.00716 10 2.00488ZM13.5672 8.69707L9.19219 13.0721C9.13415 13.1302 9.06522 13.1763 8.98934 13.2077C8.91347 13.2392 8.83214 13.2554 8.75 13.2554C8.66787 13.2554 8.58654 13.2392 8.51067 13.2077C8.43479 13.1763 8.36586 13.1302 8.30782 13.0721L6.43282 11.1971C6.31554 11.0798 6.24966 10.9207 6.24966 10.7549C6.24966 10.589 6.31554 10.43 6.43282 10.3127C6.55009 10.1954 6.70915 10.1295 6.875 10.1295C7.04086 10.1295 7.19992 10.1954 7.31719 10.3127L8.75 11.7463L12.6828 7.8127C12.7409 7.75463 12.8098 7.70856 12.8857 7.67714C12.9616 7.64571 13.0429 7.62954 13.125 7.62954C13.2071 7.62954 13.2884 7.64571 13.3643 7.67714C13.4402 7.70856 13.5091 7.75463 13.5672 7.8127C13.6253 7.87076 13.6713 7.9397 13.7027 8.01557C13.7342 8.09144 13.7504 8.17276 13.7504 8.25488C13.7504 8.337 13.7342 8.41832 13.7027 8.49419C13.6713 8.57006 13.6253 8.639 13.5672 8.69707Z" fill="black"/></svg>';
    const html = `
      <div id="${testId}-section">
        ${points.map(point => `<div class="${testId}-point">${icon}<p>${point}</p></div>`).join('')}
      </div>`;

    atcWrapper.insertAdjacentHTML('beforebegin', html);
  }

  function pageReady() {
    return document.querySelector('.module-wrap .product-form-product-template');
  }

  function waitFor(condition, timeout) {
    const stopTime = typeof timeout === 'number' ? timeout : 7000;
    let stop = false;

    window.setTimeout(function() {
      stop = true;
    }, stopTime);

    // eslint-disable-next-line no-undef
    return new Promise(function(resolve, reject) {
      (function _innerWaitFor() {
        const value = condition();

        if (stop) {
          reject();
        } else if (value) {
          resolve(value);
        } else {
          window.setTimeout(_innerWaitFor, 50);
        }
      })();
    });
  }
})(typeof unsafeWindow === 'undefined' ? window : unsafeWindow);
// eslint-disable-next-line spaced-comment
//# sourceURL=AB-02-variant-1.js